import { TFunction } from 'i18next';

export function getFamilyRelationshipLabel(family: any, t: TFunction) {
  if (!family.relationship) return '-';
  if (family.relationship === 'parent') return t('familyDirectory.relationship.parent');

  return family.relationshipNotes || t('familyDirectory.relationship.other');
}

const INVITE_STATUS_KEYS: Record<string, string> = {
  disabled: 'contacts.status.disabled',
  invited: 'contacts.status.invited',
  inviting: 'contacts.status.inviting',
  new: 'contacts.status.notInvited',
  verified: 'contacts.status.verified',
};

export function getFamilyInviteStatusLabel(status: string | undefined, t: TFunction) {
  const key = status ? INVITE_STATUS_KEYS[status] : undefined;
  return key ? t(key) : '-';
}
